import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('submit', '.js-contacts-form', e => {
    e.preventDefault();

    const form = $(e.currentTarget);
    const contacts: any = form.serializeArray().reduce(function (accum: any, current) {
      accum[current.name] = current.value;
      return accum;
    }, {});

    BX.ajax.runComponentAction('pwd:exhibition.register.contacts', 'saveContacts', {
      mode: 'class',
      data: {
        contacts
      },
    }).then((result: any) => {
      location.href = location.href.replace('contacts', 'ticket') + result.data + '/';
    })
      .catch((err: any) => console.log(err));
  });
});
